import type { QueryClient } from '@tanstack/react-query';

import { selectedTeamIdQuery, teamQuery, teamsQuery } from '../../queries/teamQuery';
import { userQuery } from '../../queries/userQuery';

export const rootLoader = async ({ queryClient }: { queryClient: QueryClient }) => {
	const userData = await queryClient.ensureQueryData(userQuery);
	const selectedTeamId = await queryClient.ensureQueryData(selectedTeamIdQuery('selectedTeamID'));
	const teams = await queryClient.ensureQueryData(teamsQuery({ state: 'active' }));
	const currentTeam = await queryClient.ensureQueryData(
		teamQuery({ teamId: selectedTeamId?.[0] || teams?.[0]?.id || '' }),
	);

	return {
		userData,
		teams,
		selectedTeamId,
		currentTeam,
	};
};
